import React from 'react'
import { useLocation } from 'react-router-dom'
import SponsorCollapse from './SponsorCollapse'

function Footer() {
    const location = useLocation()
    const current_pathname = location.pathname
    let isSubPage = current_pathname !== '/'
    let classname = ''
    let imageStyle = ''
    let sponsorHeader = ''

    if (isSubPage) {
        classname =
            'absolute bottom-0 pr-4 text-center left-2 right-2 lg:left-auto lg:right-6 copy-small-bold'
        imageStyle = 'hidden'
        sponsorHeader = 'hidden'
    } else {
        classname =
            'hidden lg:block absolute bottom-0 right-0 text-center bg-light-grey left-2 lg:left-[380px] copy-small-bold h-auto z-40 lg:h-[57px] py-auto'
        // eslint-disable-next-line no-unused-vars
        imageStyle = 'mx-2 my-2'
        // eslint-disable-next-line no-unused-vars
        sponsorHeader = 'w-full mt-4 ml-4 text-left lg:hidden'
    }

    return (
        <div className={classname}>
            <div className="flex flex-row flex-wrap items-center justify-end bg-white float-right w-full h-[65px] lg:h-[75px] lg:overflow-y-auto lg:pb-4">
                { !isSubPage && <SponsorCollapse />}
                <div className="w-full h-full pt-5 mb-4 lg:w-auto lg:min-w-0 lg:mb-0">
                    <a
                        className="ml-4 mr-4 text-xs"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://station-frankfurt.de/impressum/">
                        Legal Notice
                    </a>
                    <a
                        className="mr-4 text-xs"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://station-frankfurt.de/datenschutzerklaerung/">
                        Privacy policy
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer
